import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import { initMetaPixel } from './utils/metaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { TargetAudience } from './components/TargetAudience';
import { ProductOverview } from './components/ProductOverview';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { PackCompleto } from './components/PackCompleto';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-nutri-mint selection:text-nutri-dark" data-id="element-1">
        <Toaster position="top-center" data-id="element-2" />
        <TopBar data-id="element-3" />
        <main data-id="element-4">
          <Hero data-id="element-5" />
          <Testimonials data-id="element-6" />
          <PainPoints data-id="element-7" />
          <TargetAudience data-id="element-8" />
          <ProductOverview data-id="element-9" />
          <Modules data-id="element-10" />
          <Bonuses data-id="element-11" />
          <Comparison data-id="element-12" />
          <Pricing data-id="element-13" />
          <PackCompleto data-id="element-14" />
          <Guarantee data-id="element-15" />
          <FAQ data-id="element-16" />
        </main>
        <Footer data-id="element-17" />
      </div>
    </BrowserRouter>;
}